


export default class Service
{

    endpoint:string=process.env.REACT_APP_BASE+"/umbraco/api/gardenmap"
    contentId:string=""


    constructor(contentId:string) {
        
        this.contentId=contentId
    }



    public async GetBedData(bed:string,contentId:string):Promise<BedData>
    {

        var result=await fetch(this.endpoint+`?bed=${bed}&contentId=${contentId}`)

        if(!result.ok)
        {
            window.alert("Something went wrong please try again.")
        }

        var data:BedData=await result.json();

        return data
        
    }

    



}

export interface Plant {
    name: string;
    id: number;
  }
  
 export  interface BedData {
    bedIdentifier: string;
    description: string;
    alivePlants: Plant[];
    images: string[];
  }